export default __webpack_public_path__ + "static/media/roboto-v20-latin-500.abcf7cd8.ttf";